"use client";

import { Card } from "@/components/ui/card";
import { Heart, Award, Cpu } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurMission() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const pillars = [{
    icon: Heart,
    title: "Compassionate",
    description: "Empathetic support tailored to each student's unique learning journey"
  }, {
    icon: Award,
    title: "Expert",
    description: "Certified special education professionals with proven track records"
  }, {
    icon: Cpu,
    title: "Technology-Driven",
    description: "AI-enhanced tools that personalize instruction and track progress"
  }];
  return <section ref={sectionRef} className="relative bg-light-background py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div className={`flex flex-col justify-center space-y-8 ${isVisible ? "animate-fade-in-up" : "opacity-0"}`}>
            <div>
              <h2 className="font-display text-3xl font-bold text-foreground-light sm:text-4xl lg:text-5xl">
                Our Mission
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-light sm:text-lg">
                At FIRST CLASS RESOURCES, LLC, we empower K-12 students with diverse learning needs through mobile and virtual special education services. Leveraging advanced technology and artificial intelligence, we deliver personalized, inclusive instruction that transforms educational outcomes and builds lifelong confidence.
              </p>
            </div>

            {}
            <div className="grid grid-cols-3 gap-4 sm:gap-6">
              <div data-index={0} className="text-center">
                <div className="font-display text-2xl font-bold text-accent sm:text-3xl lg:text-4xl">
                  K-12
                </div>
                <div className="mt-1 text-xs text-muted-foreground sm:text-sm">
                  Grade Levels
                </div>
              </div>
              <div data-index={1} className="text-center">
                <div className="font-display text-2xl font-bold text-accent sm:text-3xl lg:text-4xl">
                  100%
                </div>
                <div className="mt-1 text-xs text-muted-foreground sm:text-sm">
                  Virtual & Mobile
                </div>
              </div>
              <div data-index={2} className="text-center">
                <div className="font-display text-2xl font-bold text-accent sm:text-3xl lg:text-4xl">
                  AI
                </div>
                <div className="mt-1 text-xs text-muted-foreground sm:text-sm">
                  Enhanced
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-1 lg:gap-8">
            {pillars.map((pillar, i) => {
            const Icon = pillar.icon;
            return <Card key={i} data-index={i} className={`group border border-border/20 bg-muted-light px-6 py-6 shadow-soft backdrop-blur-sm transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium focus-within:ring-2 focus-within:ring-ring ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
              animationDelay: isVisible ? `${i * 100}ms` : "0ms"
            }}>
                  <div className="flex flex-col items-center text-center">
                    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-lg bg-accent/10 transition-transform duration-[var(--duration-fast)] ease-[var(--ease-spring)] group-hover:scale-105 group-focus-within:scale-105">
                      <Icon className="h-7 w-7 text-accent-dark" />
                    </div>
                    <h3 className="font-display text-lg font-semibold text-foreground-light sm:text-xl">
                      {pillar.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                      {pillar.description}
                    </p>
                  </div>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}